<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col">
                    <div v-if="!details.length">
                        <tr>
                            <td colspan="3" rowspan="3">
                                pas de Logs
                            </td>
                        </tr>
                    </div>
                    <div class="table-responsive" v-if="details.length">
                        <table class="table table-striped">
                            <thead >
                            <th class="col-4">Date</th>
                            <th class="col-4">Type</th>
                            <th class="col-4">Desc</th>
                            </thead>
                            <tbody>
                            <tr class="detail-row" :key="detail.id" v-for="detail in details" >
                                <td>{{detail.date}}</td>
                                <td>{{detail.type}}</td>
                                <td>{{detail.description}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LogDetails",
        props: {
            details: Array
        },
    }
</script>

<style scoped>

</style>